import { MetricsForJumboEvent } from '../../../../../../analytics/constants';
import { IssueResolveNowBtnClickEvent } from '../../../../../../analytics/raise-an-issue/events';
import { reasonModel } from '../../../../../../api';

export const coreResolve = ({
  orderId,
  cartId,
  userId,
  complaintType,
  issueInfo,
  approvedMedia,
  selectedMultiRangeOptions,
  selectedSubItemList,
  resolutionOptionDetails,
  orderLevelCharges,
  isApproveComplaintFlow,
  resolutionOption,
  UpdateNextScreen,
}) => {
  const rawSelectedItems = [
    ...Object.values(selectedMultiRangeOptions || {}),
    ...(Array.isArray(selectedSubItemList) ? selectedSubItemList : []),
  ];
  const selectedItems = Array.from(
    rawSelectedItems.reduce(
      (map, item) => map.set(item?.item_id, item),
      new Map(),
    ),
    ([, item]) => item,
  );

  UpdateNextScreen({
    isLoading: true,
  });

  const resolutionSlug = isApproveComplaintFlow ? 'approve' : 'resolve';
  const orderLevelChargesInputKey = issueInfo?.order_level_select?.input?.key;

  let dataForResolve = {};
  if (isApproveComplaintFlow) {
    dataForResolve = {
      complaint_id: resolutionOptionDetails?.complaint_id,
      order_id: orderId,
      cart_id: cartId,
      complaint_type: complaintType,
      media_ids: approvedMedia,
      approved_items: selectedItems,
      resolution: resolutionOption?.resolution,
      sub_resolution: resolutionOption?.sub_resolution || null,
      is_approved_complaint: true,
    };
  } else
    dataForResolve = {
      complaint_id: resolutionOptionDetails?.complaint_id,
      sub_resolution: resolutionOption?.sub_resolution || null,
      resolution: resolutionOption?.resolution,
      product_attribute: resolutionOption?.product_attribute || null,
      order_id: orderId,
      cart_id: cartId,
      complaint_type: complaintType,
      selected_items: selectedItems,
      media_ids: approvedMedia,
      is_approved_complaint: false,
    };

  if (orderLevelChargesInputKey) {
    dataForResolve = {
      ...dataForResolve,
      [`${orderLevelChargesInputKey}`]: orderLevelCharges,
    };
  }

  const response_meta = {};

  return reasonModel
    .createResolution(dataForResolve, resolutionSlug)
    .then((response) => {
      if (!response) return null;

      if (response && response.isError === true) {
        response_meta.is_success = false;
        UpdateNextScreen({
          isLoading: false,
          isError: true,
          errorMessage: response?.message || 'Something went wrong',
        });
      } else {
        response_meta.is_success = true;
        UpdateNextScreen({
          isLoading: false,
          showSuccessScreen: true,
          resolutionSuccessDetails: response,
        });
      }
      return response;
    })
    .catch(() => {
      response_meta.is_success = false;
      UpdateNextScreen({
        isLoading: false,
        isError: true,
        errorMessage: 'Something went wrong',
      });
    })
    .then(() => {
      IssueResolveNowBtnClickEvent({
        [MetricsForJumboEvent.order_id]: orderId,
        [MetricsForJumboEvent.cart_id]: cartId,
        [MetricsForJumboEvent.customer_id]: userId,
        [MetricsForJumboEvent.feature_meta]: {
          'request_meta.complaint_id': complaintType,
          ...(resolutionOption || {}),
          'response_meta.is_success': response_meta.is_success,
        },
      });
    });
};
